export default __webpack_public_path__ + "static/media/audio_20_campana.8af9b5ce.mp3";